import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl-next';
import type { Dispatch } from 'react';

import Button from '@atlaskit/button';
import FilterIcon from '@atlaskit/icon/core/filter';
import DropdownMenu from '@atlaskit/dropdown-menu';

import type { TaskPages, TaskSpaces, TaskView } from '../tasksDefinitions.ts';

import { FiltersForm } from './FiltersForm.tsx';
import type { FiltersState } from './useFiltersReducer.ts';

const i18n = defineMessages({
	filtersButton: {
		id: 'home.views.tasks.filters.label.filtersButton',
		defaultMessage:
			'{count, plural, =0 {Filters} one {# filter applied} other {# filters applied}}',
		description: 'The button text for the filter button to open the filter menu.',
	},
});

interface FiltersProps {
	selectedTableView: TaskView;
	options?: {
		pages: TaskPages;
		spaces: TaskSpaces;
	};
	filterDispatch: Dispatch<any>;
	filterState: FiltersState;
}

export const Filters = ({
	selectedTableView,
	options,
	filterDispatch,
	filterState,
}: FiltersProps) => {
	return (
		<DropdownMenu
			placement="bottom-end"
			trigger={({ triggerRef, ...props }) => (
				<Button ref={triggerRef} iconBefore={<FilterIcon label="" />} {...props}>
					<FormattedMessage {...i18n.filtersButton} values={{ count: filterState.count }} />
				</Button>
			)}
		>
			<FiltersForm
				selectedTableView={selectedTableView}
				options={options}
				filterDispatch={filterDispatch}
				filterState={filterState}
			/>
		</DropdownMenu>
	);
};
